import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useAnalytics } from 'modules/reviews/pages/performance/Show/Analytics/analyticsContext'
import type AnalyticResult from 'modules/reviews/store/models/AnalyticResult'
import FilteredBlankSlate from 'modules/surveys/components/Analytics/_FilterBlankSlate'

import BlankSlate from '../BlankSlate'
import RawResult from './_RawResult'

interface Props {
  formName: string
}

const RawResults = ({ formName }: Props) => {
  const { analyticResults, reviewAnalyticsFilter } = useAnalytics()
  const isFilterApplied = reviewAnalyticsFilter?.default.length

  if (!analyticResults.length && isFilterApplied) return <FilteredBlankSlate />

  if (!analyticResults.length) return <BlankSlate />

  return (
    <Box gap="s32" overflowX="scroll">
      {analyticResults.map((analyticResult: AnalyticResult) => (
        <RawResult
          key={analyticResult.attributes.id}
          formName={formName}
          analyticResult={analyticResult}
        />
      ))}
    </Box>
  )
}

export default observer(RawResults)
